import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _asyncToGenerator from '@babel/runtime/helpers/asyncToGenerator';
import _regeneratorRuntime from '@babel/runtime/regenerator';
import get from 'lodash/get';
import takeRight from 'lodash/takeRight';
import PopupManager from 'element-ui/lib/utils/popup/popup-manager';
import isUndefined from 'lodash/isUndefined';
import KMessage from '@kso/ui/lib/utils/message';
import { isServerRendering, getFileIcon, getCDN } from '@kso/util';
import uniqueId from 'lodash/uniqueId';
import errors from '@kso/ui/lib/utils/errors';
import { apiList, openFunctionPage } from '@kso/sdk-super/lib/mdocs';
import UA from '@kso/ui/lib/utils/ua';
import { VIPCASHDESK } from '@kso/constants';
import { phoneMask, getExtName, mergeUrlQuery } from '@kso/ui/lib/utils/sideEffect';
export * from '@kso/ui/lib/utils/sideEffect';
export * from '@kso/ui/lib/utils/globalData';
import { call } from '@kso/ui/lib/utils/callWps';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// const { getUA } = require('@kso/util')

// 判断客户端是否为多账号版本
function isMulitKdocsClient() {
  return _isMulitKdocsClient.apply(this, arguments);
}

// 获取event.path兼容写法
function _isMulitKdocsClient() {
  _isMulitKdocsClient = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
    var apis, result;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          if (!(typeof window !== 'undefined')) {
            _context4.next = 7;
            break;
          }
          if (!UA.isTabletClient) {
            _context4.next = 7;
            break;
          }
          _context4.next = 4;
          return apiList();
        case 4:
          apis = _context4.sent;
          result = Array.isArray(apis) && apis.includes('loginOtherAccount');
          return _context4.abrupt("return", result);
        case 7:
          return _context4.abrupt("return", false);
        case 8:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _isMulitKdocsClient.apply(this, arguments);
}
var getEventPath = function getEventPath(event) {
  // chrome
  if (event.path) {
    return event.path;
  }
  // Firefox, Safari
  if (event.composedPath) {
    return event.composedPath();
  }
  // IE, etc...
  var path = [];
  var target = event.target;
  while (target.parentNode) {
    path.push(target.parentNode);
    target = target.parentNode;
  }
  return path;
};

// 如果使用element的popper popper-options的removeOnDestroy特性,需要引入此polyfill,保证在ie11及以下表现正常
var polyfillElementRemoveApi = function polyfillElementRemoveApi() {
  if (isServerRendering()) {
    return;
  }
  // from:https://github.com/jserz/js_piece/blob/master/DOM/ChildNode/remove()/remove().md
  (function (arr) {
    arr.forEach(function (item) {
      if (Object.prototype.hasOwnProperty.call(item, 'remove')) {
        return;
      }
      Object.defineProperty(item, 'remove', {
        configurable: true,
        enumerable: true,
        writable: true,
        value: function remove() {
          if (this.parentNode === null) {
            return;
          }
          this.parentNode.removeChild(this);
        }
      });
    });
  })([Element.prototype, CharacterData.prototype, DocumentType.prototype]);
};

// 初始化PopupManager的z-index
var initElPopupManagerZIndex = function initElPopupManagerZIndex(index) {
  PopupManager.zIndex = index;
};

/**
 * 创建能够缓存函数计算结果的工厂函数
 * @param {function} fn 需要缓存计算结果的函数
 * @param {number} [expire = 60 * 60 * 24] 缓存多长时间后失效，单位秒，默认一天
 */
var createFnWithCache = function createFnWithCache(fn) {
  var expire = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 60 * 60 * 24;
  if (typeof window === 'undefined') {
    return;
  }
  var cache = {};
  return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var key,
      now,
      result,
      _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          key = JSON.stringify(_args);
          now = new Date().getTime();
          if (!(cache[key] && cache[key].expiredAt > now)) {
            _context.next = 4;
            break;
          }
          return _context.abrupt("return", cache[key].data);
        case 4:
          _context.next = 6;
          return fn.apply(this, _args);
        case 6:
          result = _context.sent;
          cache[key] = {
            data: result,
            expiredAt: now + expire * 1000
          };
          return _context.abrupt("return", result);
        case 9:
        case "end":
          return _context.stop();
      }
    }, _callee, this);
  }));
};

// 获取要展示的名字
var getName = function getName(member) {
  return member.markname || member.mark_name || member.name || member.nickname || member.nick_name || member.user_name;
};

// 统一格式化接口返回成员属性
var formatMember = function formatMember(info) {
  var keysMap = {
    recent_id: 'userid',
    contact_id: 'userid',
    mark_name: 'markname',
    nick_name: 'name',
    nickname: 'name',
    user_name: 'name',
    id: 'userid',
    user_id: 'userid'
  };
  Object.keys(keysMap).forEach(function (key) {
    if (isUndefined(info[keysMap[key]]) && !isUndefined(info[key])) {
      info[keysMap[key]] = info[key];
    }
  });
  info.id = uniqueId();
  info.leaf = true;
};

// 获取企业成员项副标题
var getSubTitle = function getSubTitle(member) {
  return member.deptMoreName || member.deptName || phoneMask(member.phone) || member.email;
};
function subFileName(name) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'file';
  if (!name) {
    return '';
  }
  if (~['folder', 'normal', 'special', 'secret ', 'sharefolder', 'linkfolder', 'team', 'delfolder', 'delgroup', 'group'].indexOf(type)) {
    return name;
  } else if (type === 'link') {
    return name.split('.').slice(0, -2).join('.');
  } else {
    return name.replace(/^(.+)(\..+)$/, function ($1, $2) {
      return $2;
    });
  }
}
var removeHtmlTag = function removeHtmlTag(src) {
  return src.replace(/<\/?[\s\S]+?>/gi, function ($1) {
    if (!/^<\/?em>$/i.test($1)) {
      return '';
    }
    return $1;
  });
};
// 接口报错提示
var completeError = function completeError(e) {
  var ignoreMsg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var response = e.response,
    message = e.message;
  var _ref2 = response || {},
    data = _ref2.data,
    status = _ref2.status;
  var _ref3 = data || {},
    msg = _ref3.msg;
  // let errorText = msg || '服务器错误'
  var errorText = msg || errors.ServerError;
  if (status === 504) {
    // errorText = '服务器忙请稍后再试'
    errorText = errors.ERR_SERVER_EXCEPTION;
  }
  if (message === 'Network Error') {
    // errorText = '网络异常'
    errorText = errors.NetworkError;
  }
  if (!(msg && ignoreMsg) || !ignoreMsg) {
    KMessage.error(errorText);
  }
};
var toastError = function toastError(error) {
  KMessage.error(get(error, 'response.data.msg', errors.UnknownError));
};
var getErrorMsg = function getErrorMsg(error, defaultMsg) {
  return get(error, 'response.data.msg', defaultMsg || errors.UnknownError);
};
var getErrorResult = function getErrorResult(error) {
  return get(error, 'response.data.result');
};

/**
 * 获取公司组织结构的名字
 * @param {string} path 接口返回的组织结构路径参数
 * @returns {Array} 名称数组，第一个为公司名称，第二个为所在部门的路径，取最后两个
 */
var getOrgNames = function getOrgNames(path) {
  if (!path) {
    return [];
  }
  var deptPaths = path.split('/');
  var companyName = deptPaths.shift();
  var deptName = takeRight(deptPaths, 2).join('/');
  return [companyName, deptName];
};
function getSpaceFullType(msg) {
  /*
   * 您的WPS云空间已满
   * 此团队拥有者的云空间已满
   * 您的公司云空间已满(旧企业)
   */
  if (/WPS云空间/.test(msg)) {
    return 'MySpaceFull';
  } else if (/团队/.test(msg)) {
    return 'GroupOwnerSpaceFull';
  } else if (/公司/.test(msg)) {
    return '';
  }
  return '';
}
function getRect(element) {
  var rect;
  if (typeof element.getBoundingClientRect !== 'undefined') {
    rect = element.getBoundingClientRect();
  } else {
    var elementScrollLeft;
    var elementScrollTop;
    var actualLeft = element.offsetLeft;
    var actualTop = element.offsetTop;
    var elementHeight = element.clientHeight;
    var elementWidth = element.clientWidth;
    var current = element.offsetParent;
    while (current !== null) {
      actualLeft += current.offsetLeft;
      actualTop += current.offsetTop;
      current = current.offsetParent;
    }
    if (document.compatMode === 'BackCompat') {
      elementScrollLeft = document.body.scrollLeft;
      elementScrollTop = document.body.scrollTop;
    } else {
      elementScrollLeft = document.documentElement.scrollLeft;
      elementScrollTop = document.documentElement.scrollTop;
    }
    var left = actualLeft - elementScrollLeft;
    var top = actualTop - elementScrollTop;
    rect = {
      left: actualLeft - elementScrollLeft,
      top: actualTop - elementScrollTop,
      right: left + elementWidth,
      bottom: top + elementHeight,
      width: elementWidth,
      height: elementHeight
    };
  }
  return rect;
}
var klass = {
  hasClass: function hasClass(elem, cls) {
    cls = cls || '';
    if (cls.replace(/\s/g, '').length === 0) {
      return false;
    }
    return new RegExp(' ' + cls + ' ').test(' ' + elem.className + ' ');
  },
  addClass: function addClass(elem, cls) {
    if (!this.hasClass(elem, cls)) {
      elem.className += ' ' + cls;
    }
  },
  removeClass: function removeClass(elem, cls) {
    if (this.hasClass(elem, cls)) {
      var newClass = ' ' + elem.className.replace(/[\t\r\n]/g, '') + ' ';
      while (newClass.indexOf(' ' + cls + ' ') >= 0) {
        newClass = newClass.replace(' ' + cls + ' ', ' ');
      }
      elem.className = newClass.replace(/^\s+|\s+$/g, '');
    }
  }
};

// 根据 selector 获取距离 el 最近的父元素
function getCloseParent(el, selector) {
  var matchesSelector = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector;
  while (el) {
    if (matchesSelector.call(el, selector)) {
      return el;
    } else {
      el = el.parentElement;
    }
  }
  return null;
}
function hasClass(el, className) {
  if (el.classList) {
    return el.classList.contains(className);
  } else {
    return !!el.className.match(new RegExp('(\\s|^)' + className + '(\\s|$)'));
  }
}

/**
 * 将一个文件的大小尺寸转化成一个带单位的字符串
 *
 * @param {number} size
 * @returns {string}
 */
function convertUnit(size) {
  var point = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var fsize = parseFloat(size);
  var sizeUnit = 'B';
  while (fsize >= 1024) {
    fsize = fsize / 1024;
    if (sizeUnit === 'B') {
      sizeUnit = 'KB';
    } else if (sizeUnit === 'KB') {
      sizeUnit = 'MB';
    } else if (sizeUnit === 'MB') {
      sizeUnit = 'GB';
    } else if (sizeUnit === 'GB') {
      sizeUnit = 'TB';
    } else if (sizeUnit === 'TB') {
      sizeUnit = 'PB';
    } else if (sizeUnit === 'PB') {
      sizeUnit = 'EB';
      break;
    }
  }
  fsize = fsize.toFixed(point);
  if (sizeUnit === 'B') {
    fsize = parseInt(size);
  }
  return fsize + ' ' + sizeUnit;
}
function yunIcon(fname, ftype) {
  var fileSplit = fname ? fname.split('.') : 'unknown';
  if (fileSplit.length === 1 && ftype !== 'file' && ftype !== 'delfile' && ftype !== 'sharefile') {
    return 'folder';
  }
  var ext = fileSplit[fileSplit.length - 1].toLowerCase();
  var res = 'unknown';
  var mapping = {
    img: ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'heic', 'webp'],
    // psd不支持预览
    zip: ['zip', '7z', 'rar', 'iso'],
    doc: ['wps', 'wpt', 'doc', 'docx', 'dot', 'rtf', 'xml', 'docm', 'dotm', 'wdoc'],
    xls: ['et', 'ett', 'xls', 'xlsx', 'xlsm', 'xlsb', 'xlam', 'xltx', 'xltm', 'xls', 'xlt', 'xla', 'xlw', 'odc', 'uxdc', 'dbf', 'prn', 'wxls', 'csv'],
    ppt: ['dps', 'dpt', 'pptx', 'ppt', 'pptm', 'ppsx', 'pps', 'ppsm', 'potx', 'pot', 'potm', 'wpd', 'wppt'],
    txt: ['txt', 'text'],
    pdf: ['pdf'],
    pom: ['pom'],
    pof: ['pof'],
    h5: ['h5'],
    note: ['wpsnote'],
    form: ['form'],
    video: ['asf', 'avi', 'wm', 'wmp', 'wmv', 'ram', 'rm', 'rmvb', 'rp', 'rpm', 'rt', 'smi', 'smil', 'dat', 'm1v', 'm2p', 'm2t', 'm2ts', 'm2v', 'mp2v', 'mpe', 'mpeg', 'mpg', 'mpv2', 'pss', 'pva', 'tp', 'tpr', 'ts', 'm4b', 'm4p', 'm4v', 'mp4', 'mpeg4', '3g2', '3gp', '3gp2', '3gpp', 'mov', 'qt', 'f4v', 'flv', 'hlv', 'swf', 'ifo', 'vob', 'amv', 'bik', 'csf', 'divx', 'evo', 'ivm', 'mkv', 'mod', 'mts', 'ogm', 'pmp', 'scm', 'tod', 'vp6', 'webm', 'xlmv'],
    audio: ['aac', 'ac3', 'amr', 'ape', 'cda', 'dts', 'flac', 'm1a', 'm2a', 'm4a', 'mid', 'midi', 'mka', 'mp2', 'mp3', 'mpa', 'ogg', 'ra', 'tak', 'tta', 'wav', 'wma', 'wv'],
    otl: ['otl'],
    kw: ['kw'],
    dbt: ['dbt'],
    ofd: ['ofd'],
    ksheet: ['ksheet']
  };
  if (fileSplit.length !== 1) {
    Object.keys(mapping).forEach(function (icon) {
      if (~mapping[icon].indexOf(ext)) {
        res = icon;
        return false;
      }
    });
  }
  return res;
}
var noop = function noop() {};
function showError(input) {
  if (input.silent) {
    return;
  }
  var _ref4 = input || {},
    response = _ref4.response;
  var _ref5 = response || {},
    data = _ref5.data;
  var _ref6 = data || {},
    result = _ref6.result,
    msg = _ref6.msg;
  if (!result && typeof data === 'string') {
    input = data;
  }
  var errorResult = getErrorResult(input);
  var errorMessage = errors[errorResult] || msg || input;
  if (input && input.message === 'Network Error') {
    errorMessage = errors.NetworkError;
  }
  KMessage.error(errorMessage);
}
var updateCenter = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(vm) {
    var expandOption,
      event,
      _expandOption$getPage,
      getPagePosition,
      $dialog,
      _ref8,
      _ref8$clientWidth,
      clientWidth,
      _ref8$clientHeight,
      clientHeight,
      positionInfo,
      width,
      left,
      _positionInfo$scale,
      scale,
      LEFT,
      _left_,
      _args2 = arguments;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          expandOption = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
          if (!(vm && vm.visible)) {
            _context2.next = 19;
            break;
          }
          event = expandOption.event, _expandOption$getPage = expandOption.getPagePosition, getPagePosition = _expandOption$getPage === void 0 ? function () {} : _expandOption$getPage;
          $dialog = vm.$refs.dialog && vm.$refs.dialog.$refs.dialog; // 弹窗的宽度必须在计算前隐藏弹窗计算获取，避免隐藏后进行计算为0情况，导致
          _ref8 = $dialog || {}, _ref8$clientWidth = _ref8.clientWidth, clientWidth = _ref8$clientWidth === void 0 ? 0 : _ref8$clientWidth, _ref8$clientHeight = _ref8.clientHeight, clientHeight = _ref8$clientHeight === void 0 ? 0 : _ref8$clientHeight;
          if (!event) {
            // 计算前先隐藏弹窗，解决初始化首次打开弹窗定位抖动问题，只执行一次，resize事件时不再执行
            $dialog.style.display = 'none';
          }
          _context2.prev = 6;
          _context2.next = 9;
          return getPagePosition();
        case 9:
          positionInfo = _context2.sent;
          if (positionInfo.width) {
            width = positionInfo.width, left = positionInfo.left, _positionInfo$scale = positionInfo.scale, scale = _positionInfo$scale === void 0 ? 1 : _positionInfo$scale; // let TOP = (height - $dialog.clientHeight) / 2
            LEFT = (width / scale - clientWidth) / 2; // let _top_ = parseInt((TOP - top >=0 ? TOP - top : 0))
            _left_ = parseInt(LEFT - left >= 0 ? left / scale : 0);
            $dialog.parentNode.style.left = "-".concat(_left_, "px");
            // 如果客户端窗口高度小于弹窗高度，重新设置弹窗top值，保证弹窗顶部不被遮挡，解决禅道bug#2426
            $dialog.style.top = clientHeight > positionInfo.clientHeight ? "".concat((clientHeight - positionInfo.clientHeight) / clientHeight * 100 + 50, "%") : '50%';
          }
          _context2.next = 16;
          break;
        case 13:
          _context2.prev = 13;
          _context2.t0 = _context2["catch"](6);
          console.log(_context2.t0);
        case 16:
          _context2.prev = 16;
          if ($dialog) {
            $dialog.parentNode.style.display = 'block';
            $dialog.style.display = 'block'; // 弹窗计算完后再显示
          }
          return _context2.finish(16);
        case 19:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[6, 13, 16, 19]]);
  }));
  return function updateCenter(_x) {
    return _ref7.apply(this, arguments);
  };
}();

// 是否图片文件
var isImgFile = function isImgFile(fname) {
  return /.(jpg|jpeg|png|gif|bmp)$/.test(fname.toLowerCase());
};

// 是否图片快捷方式文件
var isImgLinkFile = function isImgLinkFile(fname, ftype) {
  if (['link', 'dellink'].includes(ftype)) {
    var extRegResult = /\.([^.]+)\.[^.]+$/.exec(fname);
    var ext = (extRegResult && extRegResult[1] || '').toLowerCase();
    return /(jpg|jpeg|png|gif|bmp)$/.test(ext);
  }
  return false;
};

// 获取文件id
var _getFileId = function getFileId(file) {
  if (!file) {
    return;
  }
  if (file.file) {
    return _getFileId(file.file);
  }
  return file.fileid || file.id;
};
var getFileName = function getFileName(file) {
  return file.fname || file.name || file.share_name || file.desc;
};

// userRole˙转换
var initUserRole = function initUserRole(userRole) {
  var map = {
    1: 'superadm',
    2: 'admin',
    3: 'member'
  };
  return map[userRole] || 'member';
};
var updateQueryStringParameter = function updateQueryStringParameter(uri, key, value) {
  if (!value) {
    return uri;
  }
  var re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
  var separator = uri.indexOf('?') !== -1 ? '&' : '?';
  if (uri.match(re)) {
    return uri.replace(re, '$1' + key + '=' + value + '$2');
  } else {
    return uri + separator + key + '=' + value;
  }
};

/**
 *
 * @param {*} uri
 * @param {*} mapping  [{ key, value }]
 * @returns uri
 */
var updateQueryStringParams = function updateQueryStringParams(uri, mapping) {
  var result = uri;
  mapping.forEach(function (item) {
    result = updateQueryStringParameter(result, item.key, item.value);
  });
  return result;
};

/**
 * 唤起团队会员购买弹窗
 * https://kdocs.cn/l/cedcQqhpO2BL
 *
 * vippay: 团队会员支付首页（购买页）
 * assignvip: 团队会员分配页
 */
var callTeamVipPluginDialog = function callTeamVipPluginDialog() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  // const url = 'https://docer-vcl.kdocs.cn/v1/plugins/teamvip/index'
  var baseUrl = options.baseUrl,
    path = options.path,
    _options$scriptId = options.scriptId,
    scriptId = _options$scriptId === void 0 ? 'TeamVipPluginDialog' : _options$scriptId;
  return new Promise(function (resolve, reject) {
    if (!baseUrl) {
      reject('error script src');
    }

    // 通过scriptId 判断script只需加载一次
    var existScriptEle = document.getElementById(scriptId);
    if (existScriptEle) {
      resolve();
    } else {
      try {
        var scriptEle = document.createElement('script');
        scriptEle.id = scriptId;
        scriptEle.type = 'text/javascript';
        scriptEle.async = true;
        scriptEle.src = baseUrl + path;
        var x = document.getElementsByTagName('head')[0];
        scriptEle.onload = function () {
          resolve();
        };
        x.insertBefore(scriptEle, x.firstChild);
      } catch (error) {
        reject(error);
      }
    }
  });
};

/**
 * 根据指定参数截断文件名
 * @param {string} filename 文件名
 * @param {number} sliceLength 截断长度
 * @param {boolean} appendEllipsis 附加省略号
 * @param {boolean} includeSuffix 包含后缀计算
 * @returns 截断后的文件名
 */
var sliceFilename = function sliceFilename(filename) {
  var sliceLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 15;
  var appendEllipsis = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var includeSuffix = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var tempName = subFileName(filename);
  var tempExt = getExtName(filename);
  var realSliceLength = includeSuffix ? sliceLength - tempExt.length : sliceLength;
  // 超过指定长度
  if (tempName.length > realSliceLength) {
    return "".concat(tempName.slice(0, realSliceLength)).concat(appendEllipsis ? '...' : '', ".").concat(tempExt);
  } else {
    return filename;
  }
};
// 获取埋点filetype
var getDwFileType = function getDwFileType() {
  var fname = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var ftype = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var _filetype = '';
  if (['linkfolder', 'folder', 'delfolder'].includes(ftype)) {
    _filetype = 'folder';
  } else if (ftype && ftype !== 'file' && ftype !== 'delfile' && ftype !== 'delsharefile' && ftype !== 'sharefile') {
    _filetype = 'folder';
  } else if (fname) {
    var iconType = getFileIcon(fname);
    var typeList = ['otl', 'ksheet', 'dbt', 'doc', 'xls', 'ppt', 'pof', 'pom', 'kw', 'img', 'ckt', 'pdf'];
    var dwTypeMap = {
      doc: 'wps',
      xls: 'et',
      ppt: 'wpp',
      dbt: 'db'
    };
    _filetype = typeList.includes(iconType) ? dwTypeMap[iconType] || iconType : 'unknown';
  }
  return _filetype;
};
var PAGE_SIZE = 30;
var GET_PAGINATION = function GET_PAGINATION() {
  var pageSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : PAGE_SIZE;
  return {
    fetching: false,
    start: 0,
    size: pageSize,
    nomore: false
  };
};

/**
 * @param {*} options
 */
var usePageReq = /*#__PURE__*/function () {
  var _usePageReq = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var options,
      _options$params,
      params,
      _options$options,
      otherOptions,
      _options$reqFunc,
      reqFunc,
      _options$errorHandle,
      errorHandle,
      _options$paginationNa,
      paginationName,
      getResult,
      _otherOptions$pageSiz,
      pageSize,
      _options$pagination,
      pagination,
      _pagination$start,
      start,
      _pagination$size,
      size,
      _pagination$fetching,
      fetching,
      _pagination$nomore,
      nomore,
      isStart,
      res,
      hasError,
      startName,
      sizeName,
      result,
      _result,
      nextPagination,
      _args3 = arguments;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          options = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};
          _options$params = options.params, params = _options$params === void 0 ? {} : _options$params, _options$options = options.options, otherOptions = _options$options === void 0 ? {} : _options$options, _options$reqFunc = options.reqFunc, reqFunc = _options$reqFunc === void 0 ? function () {} : _options$reqFunc, _options$errorHandle = options.errorHandle, errorHandle = _options$errorHandle === void 0 ? function () {} : _options$errorHandle, _options$paginationNa = options.paginationName, paginationName = _options$paginationNa === void 0 ? {
            start: 'start',
            // offset
            size: 'size' // count
          } : _options$paginationNa, getResult = options.getResult;
          _otherOptions$pageSiz = otherOptions.pageSize, pageSize = _otherOptions$pageSiz === void 0 ? PAGE_SIZE : _otherOptions$pageSiz;
          _options$pagination = options.pagination, pagination = _options$pagination === void 0 ? GET_PAGINATION(pageSize) : _options$pagination;
          _pagination$start = pagination.start, start = _pagination$start === void 0 ? 0 : _pagination$start, _pagination$size = pagination.size, size = _pagination$size === void 0 ? PAGE_SIZE : _pagination$size, _pagination$fetching = pagination.fetching, fetching = _pagination$fetching === void 0 ? false : _pagination$fetching, _pagination$nomore = pagination.nomore, nomore = _pagination$nomore === void 0 ? false : _pagination$nomore;
          if (!(fetching || nomore)) {
            _context3.next = 7;
            break;
          }
          return _context3.abrupt("return", {
            nextPagination: pagination,
            isStart: false,
            result: [],
            res: null
          });
        case 7:
          isStart = start === 0;
          res = null;
          hasError = false;
          _context3.prev = 10;
          pagination.fetching = true;
          startName = get(paginationName, 'start', 'start');
          sizeName = get(paginationName, 'size', 'size');
          _context3.next = 16;
          return reqFunc(_objectSpread(_defineProperty(_defineProperty({}, startName, start), sizeName, size), params));
        case 16:
          res = _context3.sent;
          pagination.fetching = false;
          _context3.next = 25;
          break;
        case 20:
          _context3.prev = 20;
          _context3.t0 = _context3["catch"](10);
          pagination.fetching = false;
          hasError = true;
          errorHandle(_context3.t0);
        case 25:
          result = [];
          if (typeof getResult === 'function') {
            _result = getResult(res);
            result = Array.isArray(_result) ? _result : [];
          } else if (Array.isArray(res)) {
            result = res;
          } else if (Array.isArray(get(res, 'data.result'))) {
            result = res.data.result;
          } else if (Array.isArray(get(res, 'result'))) {
            result = res.result;
          }
          nextPagination = _objectSpread(_objectSpread({}, pagination), {}, {
            start: start,
            size: size,
            nomore: nomore
          });
          if (result.length === pageSize) {
            nextPagination.start += pageSize;
            nextPagination.nomore = false;
          } else if (!hasError) {
            // 下一页没有了
            nextPagination.start += result.length;
            nextPagination.nomore = true;
          }
          return _context3.abrupt("return", {
            nextPagination: nextPagination,
            isStart: isStart,
            result: result,
            res: res
          });
        case 30:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[10, 20]]);
  }));
  function usePageReq() {
    return _usePageReq.apply(this, arguments);
  }
  return usePageReq;
}();
var composeUrl = function composeUrl(url, queries) {
  var _queries = Object.keys(queries).map(function (key) {
    return "".concat(key, "=").concat(queries[key]);
  }).join('&');
  return url.includes('?') ? "".concat(url, "&").concat(_queries) : "".concat(url, "?").concat(_queries);
};
var getVipCashDeskUrl = function getVipCashDeskUrl() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return "".concat(VIPCASHDESK, "/vcl_svr/static/wps_payment").concat(mergeUrlQuery(query));
};

/**
 * @description 适配各端的跳转
 * @param {String} url 跳转地址
 */
var commonPageJump = function commonPageJump(url) {
  if (window.cefQuery || window.wpsQuery) {
    // wps PC客户端
    try {
      call({
        method: 'common.util.innerOpenUrl',
        params: {
          url: url
        }
      });
    } catch (error) {
      window.open(url);
    }
  } else if (UA.moffice) {
    // wps 移动端
    window.wps.naviagteTo({
      mode: 'web',
      url: url
    });
  } else if (UA.mdocs) {
    // 金山文档移动端
    openFunctionPage({
      url: url,
      needTitleBar: true
    });
  } else if (UA.wxminiprogram || UA.qqminiprogram || UA.isMobile === true) {
    // 移动H5
    location.href = url;
  } else {
    window.open(url);
  }
};
var completionCdn = function completionCdn() {
  var cdn = getCDN();
  if (cdn && cdn.slice(0, 2) === '//') {
    cdn = 'https:' + cdn;
  }
  return cdn;
};

// 新版个人卡片，kgp2场景特殊处理
function isFromKgp2() {
  var url = window.location.href;
  return url.includes('/kgp2/');
}

export { GET_PAGINATION, PAGE_SIZE, callTeamVipPluginDialog, commonPageJump, completeError, completionCdn, composeUrl, convertUnit, createFnWithCache, formatMember, getCloseParent, getDwFileType, getErrorMsg, getErrorResult, getEventPath, _getFileId as getFileId, getFileName, getName, getOrgNames, getRect, getSpaceFullType, getSubTitle, getVipCashDeskUrl, hasClass, initElPopupManagerZIndex, initUserRole, isFromKgp2, isImgFile, isImgLinkFile, isMulitKdocsClient, klass, noop, polyfillElementRemoveApi, removeHtmlTag, showError, sliceFilename, subFileName, toastError, updateCenter, updateQueryStringParameter, updateQueryStringParams, usePageReq, yunIcon };
